export default __webpack_public_path__ + "static/media/sayno_logo.fa4f8799.jpeg";